export const Global = {
  //URL_API: `http://${self.location.host.split(':')[0]}:3000/api/`,
  //URL_ATM: `http://${self.location.host.split(':')[0]}:3000/atm/`,
  URL_API: `https://qrocercaapi.kio-monitor.com/api/`,
  URL_ATM: `https://qrocercaapi.kio-monitor.com/atm/`,
  URL_SOCKET: `https://qrocercaapi.kio-monitor.com`,
  //URL_API: `http://127.0.0.1:3000/api/`,
  //URL_ATM: `http://127.0.0.1:3000/atm/`,
  //URL_SOCKET: `http://127.0.0.1:3000`
};
